import { ElementGeometry } from "./ElementGeometry";
import { CsgUtils } from "../CsgUtils";
import { Util } from "../../utils/Util";
export class Plane_BottomTop extends ElementGeometry {
    getType() {
        return ("Plane_BottomTop");
    }
    setMesh(pMesh) {
        //
    }
    constructor(pRoomManager, pElement) {
        super(pRoomManager, pElement);
        this.mRoomElement = pElement;
        this.mRoomManager = pRoomManager;
    }
    getInitialParams() {
        let tParams = {};
        tParams.width = 0.5;
        tParams.height = 0;
        tParams.floorOffset = 0.0;
        tParams.color = "#999999";
        return (tParams);
    }
    create2dGeometry(pParent) {
        this.createPlane(pParent);
    }
    create3dGeometry(pParent) {
        this.createPlane(pParent);
    }
    //// private ///////////////////////////////////////////////////////////////////////////////
    createCSG(pParent, pCAG, pHeight) {
        let tCSG = Util.CAG2CSG(pCAG);
        let tMeshes = CsgUtils.buildMeshes(tCSG, this.mScene);
        if (tMeshes == null)
            return (null);
        for (let tMesh of tMeshes) {
            tMesh.parent = pParent;
            tMesh.name = "shape2d_BuildingBottomTop";
            this.mRoomManager.app.model.layers.setMeshLayer(tMesh, "room:Building_Layer");
            tMesh.material = this.mRoomElement.localMaterial; // this.mRoomManager.MatManager.getMaterial(this.mRoomElement.materialId);
            let tMeshBottom = tMesh.clone();
            tMeshBottom.makeGeometryUnique();
            tMeshBottom.flipFaces(true);
            if (this.mRoomElement.RE_reference !== null) {
                let t_RE = this.mRoomElement.RE_reference;
                if (t_RE.GroupMeshOpacity != 1) {
                    tMesh.renderingGroupId = 1;
                    tMeshBottom.renderingGroupId = 1;
                }
                tMesh.visibility = t_RE.BuildingOpacity; //t_RE.GroupMeshOpacity;
                tMeshBottom.visibility = t_RE.BuildingOpacity; //t_RE.GroupMeshOpacity;
            }
            tMesh.position.y = pHeight;
        }
        return (tMeshes[0]);
    }
    createPlane(pParent) {
        if (this.mRoomElement.RE_reference == null)
            return (null);
        if (this.mRoomElement.RE_reference.CAG == null)
            return (null);
        let tMesh = this.createCSG(pParent, this.mRoomElement.RE_reference.CAG, this.mRoomElement.RE_reference.height);
        return (tMesh);
    }
}
